import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { UsageSettings } from "@/components/settings/usage-settings";
import { creditsQuery } from "@/lib/loaders";

/**
 * Seeds the credit balance in the loader so the plan name and balance show
 * immediately instead of a spinner + "—" on first paint. The ledger still loads
 * client-side with its own skeleton.
 */
export const Route = createFileRoute("/_workspace/settings/usage")({
  loader: ({ context }) => context.queryClient.ensureQueryData(creditsQuery),
  component: SettingsUsagePage,
});

function SettingsUsagePage() {
  const { data: initialCredits } = useQuery(creditsQuery);
  return <UsageSettings initialCredits={initialCredits ?? null} />;
}
